<template>
  <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <SelectVue v-model="inquiryFormData.clientId"
                   :options="clientDropdown"
                   :required="true"
                   :disabled="disable"
                   label="Kostenträger"
                   placeholder="Wählen Sie Kostenträger"
                   :validation="vPrivateCoaching$.clientId"
                   :messages="vPrivateCoaching$.clientId.required.$message"
                   @update:modelValue="onChangeClientId"/>

        <SelectVue v-model="inquiryFormData.courseId"
                   :options="courseDropdown"
                   :required="true"
                   :disabled="disable"
                   label="Bezeichnung"
                   placeholder="Leistungsart auswählen"
                   :validation="vPrivateCoaching$.courseId"
                   :messages="vPrivateCoaching$.courseId.required.$message"
                   @update:modelValue="onChangeCourseId"/>

        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <Datepicker
                v-model="inquiryFormData.startDate"
                :required="true"
                label="Start"
                position="down"
                :validation="vPrivateCoaching$.startDate"
                :messages="vPrivateCoaching$.startDate.required.$message"/>

            <div v-if="billingTypeDropdown && billingTypeDropdown.length">
              <SelectVue v-model="inquiryFormData.billingType"
                         :options="billingTypeDropdown"
                         :required="true"
                         label="Art der Abrechnung"
                         placeholder="Art der Abrechnung"
                         :validation="vPrivateCoaching$.billingType"
                         :messages="vPrivateCoaching$.billingType.required.$message"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <Datepicker
                v-model="inquiryFormData.endDate"
                :required="true"
                label="Ende"
                position="down"
                :validation="vPrivateCoaching$.endDate"
                :messages="vPrivateCoaching$.endDate.required.$message"/>

            <BaseInput v-model="inquiryFormData.clerk"
                       label="Sachbearbeiter"/>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            AVGS Gültigkeit
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <Datepicker
                v-model="inquiryFormData.minDateOfFirstMeeting"
                :required="true"
                label="Start"
                :validation="vPrivateCoaching$.minDateOfFirstMeeting"
                :messages="vPrivateCoaching$.minDateOfFirstMeeting.required.$message"/>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <Datepicker
                v-model="inquiryFormData.maxDateOfFirstMeeting"
                :required="true"
                label="Ende"
                :validation="vPrivateCoaching$.maxDateOfFirstMeeting"
                :messages="vPrivateCoaching$.maxDateOfFirstMeeting.required.$message"/>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 text-center">
        <BaseToggle
            v-model="inquiryFormData.requiresSignature"
            label="Unterschriftspflichtig"/>

        <BaseToggle
            v-model="inquiryFormData.digitalSignature"
            label="Digitale Unterschrift"/>

        <BaseToggle
            v-model="inquiryFormData.assumptionOfCosts"
            @change="onAssumptionOfCostsChange"
            label="Fahrtkostenabrechnung"/>

        <div class="row d-flex justify-content-center">
          <BaseRadio
              v-model="inquiryFormData.arrivalType"
              label="Bus"
              name="arrivalType"
              id="1"
              classFormGroup="col-auto"
              :disabled="isCostsAssumedDisabled"
          />
          <BaseRadio
              v-model="inquiryFormData.arrivalType"
              label="Auto"
              name="arrivalType"
              id="2"
              classFormGroup="col-auto"
              :disabled="isCostsAssumedDisabled"
          />
          <BaseRadio
              v-model="inquiryFormData.arrivalType"
              label="Sonstige"
              name="arrivalType"
              id="3"
              classFormGroup="col-auto"
              :disabled="isCostsAssumedDisabled"
          />
        </div>
        <div class="row d-flex justify-content-center">
          <BaseNumber
              v-model="inquiryFormData.distance"
              label="Summe An- & Abreise in km"
              :disabled="isCostsAssumedDisabled"
          />
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <div v-if="moduleDropdown && moduleDropdown.length">
          <SelectVue v-model="inquiryFormData.moduleIds"
                     :options="moduleDropdown"
                     :is-clear="true"
                     :is-multi="true"
                     :required="true"
                     label="Module"
                     positionType="top"
                     :validation="vPrivateCoaching$.moduleIds"
                     :messages="vPrivateCoaching$.moduleIds?.required?.$message"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-if="locationDropdown && locationDropdown.length">
          <SelectVue v-model="inquiryFormData.locationIds"
                     :options="locationDropdown"
                     :is-clear="true"
                     :is-multi="true"
                     :required="true"
                     :disabled="disable"
                     label="Stanort"
                     positionType="top"
                     :validation="vPrivateCoaching$.locationIds"
                     :messages="vPrivateCoaching$.locationIds?.required?.$message"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-if="coachDropdown && coachDropdown.length">
          <SelectVue v-model="inquiryFormData.coachIds"
                     :options="coachDropdown"
                     :is-clear="true"
                     :is-multi="!disable"
                     :required="true"
                     label="Trainer"
                     positionType="top"
                     :validation="vPrivateCoaching$.coachIds"
                     :messages="vPrivateCoaching$.coachIds?.required?.$message"/>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center w-100 mt-3">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup>
import coursePrivateCoachingService from '@/api/Course/PrivateCoaching';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { getClientDropdown } from '@/shared/dropdowns';
import { requiredRule } from '@/shared/validators/validationRules';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import { computed, defineEmits, defineProps, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaEnumsState     = piniaEnumsStore();
const getEnums            = computed(() => piniaEnumsState.enums);
const { t }               = useI18n();
const courseDropdown      = ref([]);
const clientDropdown      = ref([]);
const coachDropdown       = ref([]);
const locationDropdown    = ref([]);
const billingTypeDropdown = ref([]);
const moduleDropdown      = ref([]);

const isLoaded               = ref(false);
const modalOpening           = ref(true);
const isSubmitting           = ref(false);
const isCostsAssumedDisabled = ref(true);
const disable                = ref(false);
const emit                   = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  unemployedId: {
    type: Number,
    required: true,
  },
  locationName: {
    type: String,
    required: true,
  },
  locationId: {
    type: Number,
    required: true,
  },
  privateCoachingId: {
    type: [ Number, String, null ],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const inquiryFormData = ref({
  unemployedId: props.unemployedId, // !!! IMPORTANT
  courseId: null,
  clientId: null,
  operationType: '',
  clerk: '',
  startDate: '',
  endDate: '',
  billingType: '',
  minDateOfFirstMeeting: '',
  maxDateOfFirstMeeting: '',
  requiresSignature: true,
  digitalSignature: true,
  assumptionOfCosts: false,
  arrivalType: '1',
  distance: 0,
  moduleIds: [],
  coachIds: [],
  locationIds: [],
});

const inquiryFormRules = ref({
  unemployedId: requiredRule(t),
  courseId: requiredRule(t),
  clientId: requiredRule(t),
  operationType: requiredRule(t),
  startDate: requiredRule(t),
  endDate: requiredRule(t),
  billingType: requiredRule(t),
  minDateOfFirstMeeting: requiredRule(t),
  maxDateOfFirstMeeting: requiredRule(t),
  coachIds: requiredRule(t),
  locationIds: requiredRule(t),
  moduleIds: '',
});

const computedRules     = computed(() => inquiryFormRules.value);
const vPrivateCoaching$ = useVuelidate(computedRules, inquiryFormData);

watch(
    // On every location id change coach dropdown needs to be filled
    () => inquiryFormData.value.locationIds,
    async (newValue, oldValue) => {
      if (!modalOpening.value) {
        await onChangeLocationIds(newValue);
      }
    },
    { deep: true }, // Important for arrays/objects
);

async function submitForm() {
  vPrivateCoaching$.value.$touch();
  if (vPrivateCoaching$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.privateCoachingId) {
      inquiryFormData.value.coachIds = [ inquiryFormData.value.coachIds ];
      await privateCoachingService.putInquiryPrivateCoaching(inquiryFormData.value, +props.privateCoachingId);
    } else {
      await privateCoachingService.postInquiryPrivateCoaching(inquiryFormData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPrivateCoachingData(privateCoachingId) {
  try {
    CloseToast();
    const { data }      = await privateCoachingService.getPrivateCoaching(privateCoachingId);
    const status        = data.data.status;
    const clientId      = data.data?.client.id;
    const courseId      = data.data?.nameOfCoaching.id;
    const modules       = data.data?.modules || [];
    const locations     = data.data?.locations || [];
    const operationType = data?.data?.nameOfCoaching.operationType;
    const moduleIds     = modules.map(module => module?.id).filter(id => id != null);
    const locationIds   = locations.map(location => location?.id).filter(id => id != null);

    await onChangeClientId(clientId);
    await onChangeCourseId(courseId);
    await onChangeLocationIds(locationIds, locations);

    let coachIds = [];
    if (status === 'in_allocation') {
      const coaches = data.data?.coaches || [];
      coachIds      = coaches.map(coach => coach?.id).filter(id => id != null);
    } else {
      disable.value = true;
      coachIds      = data.data?.coach1?.id;
    }

    inquiryFormData.value = {
      ...data.data,
      unemployedId: props.unemployedId,
      courseId: courseId,
      clientId: clientId,
      moduleIds: moduleIds,
      locationIds: locationIds,
      coachIds: coachIds,
      operationType: operationType,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeClientId(clientId) {
  try {
    // Change clientId fill course and location dropdown
    inquiryFormData.value.courseId  = null;
    inquiryFormData.value.moduleIds = [];
    courseDropdown.value            = [];
    moduleDropdown.value            = [];

    if (clientId) {
      const { data } = await privateCoachingService.getInquiryClientData(+clientId);

      courseDropdown.value = data?.data?.courses.map(item => ({
        label: `${item.name}`,
        value: item?.id,
      }));

      locationDropdown.value = data?.data?.locations.map(item => ({
        label: `${item.name}`,
        value: item?.id,
      }));

      inquiryFormData.value.locationIds = data?.data?.locations.map(item => item?.id) || [];
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeCourseId(courseId) {
  try {
    // Change course id fill module dropdown
    if (courseId) {
      const { data: courseData }          = await coursePrivateCoachingService.getCourse(courseId);
      const operationType                 = courseData?.data?.operationType;
      inquiryFormData.value.operationType = operationType;

      if (operationType === 'modular_integration_coaching' || operationType === 'go_work_mobile') {
        inquiryFormRules.value = {
          ...inquiryFormRules.value,
          moduleIds: requiredRule(t),
        };

        moduleDropdown.value            = courseData?.data?.modules.map(item => ({
          label: `${item.name}`,
          value: item?.id,
        }));
        inquiryFormData.value.moduleIds = courseData?.data?.modules.map(item => item?.id) || [];
      } else {
        inquiryFormData.value.moduleIds = [];
        inquiryFormRules.value          = {
          ...inquiryFormRules.value,
          moduleIds: '',
        };

        moduleDropdown.value = [];
      }
    }

  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeLocationIds(locationIds, locations = null) {
  try {
    // Locations
    if (Array.isArray(locations) && locations.length > 0) {
      locationDropdown.value = locations.map(item => ({
        label: `${item.name}`,
        value: item?.id,
      }));
    }

    // Change location ids fill coach dropdown
    const { data } = await privateCoachingService.getInquiryCoachesFromLocations(locationIds);

    coachDropdown.value = data?.data?.coaches.map(item => ({
      label: `${item.name}`,
      value: item?.id,
    }));

    inquiryFormData.value.coachIds = data?.data?.coaches.map(item => item?.id) || [];
  } catch (error) {
    await ErrorToast(error);
  }
}

function onAssumptionOfCostsChange(newValue) {
  isCostsAssumedDisabled.value      = !newValue.target.checked;
  inquiryFormData.value.arrivalType = '1';
  inquiryFormData.value.distance    = 0;
}

async function getPrivateCoachingBillingTypeEnum() {
  billingTypeDropdown.value = getEnums?.value?.privateCoachingBillingTypes || [];
}

onMounted(async () => {
  await getClientDropdown(clientDropdown);
  await getPrivateCoachingBillingTypeEnum();

  if (props.privateCoachingId) {
    await getPrivateCoachingData(props.privateCoachingId);
  }

  isLoaded.value     = true;
  modalOpening.value = false;
});


</script>
<style scoped>

</style>